import "./styles.css";

import CTAForm from "../../components/CTAForm";

import bullet from "../../assets/bullet.png";
import about2_1 from "../../assets/about2_1.png";
import about2_2 from "../../assets/about2_2.png";

const About = () => {
  return (
    <section id="about">
      <article className="about1">
        <div className="container">
          <h1 className="title">
            Transforme as Inspeções de Segurança com{" "}
            <span>Tecnologia Móvel</span>
          </h1>

          <div className="gallery">
            <div className="item">
              <figure>
                <img src={bullet} alt="Bullet Point" />
              </figure>

              <p className="text">
                O SAV revoluciona a gestão de segurança no local de trabalho
                através da sua aplicação móvel intuitiva.
              </p>
            </div>

            <div className="item">
              <figure>
                <img src={bullet} alt="Bullet Point" />
              </figure>

              <p className="text">
                O sistema gera, automaticamente, relatórios de conformidade
                detalhados, poupando horas de trabalho administrativo e
                garantindo que nada passa despercebido.
              </p>
            </div>

            <div className="item">
              <figure>
                <img src={bullet} alt="Bullet Point" />
              </figure>

              <p className="text">
                Realize inspeções abrangentes diretamente do seu smartphone ou
                tablet, eliminando formulários em papel e documentação manual.
              </p>
            </div>

            <div className="item">
              <figure>
                <img src={bullet} alt="Bullet Point" />
              </figure>

              <p className="text">
                A nossa plataforma, orientada por IA, transforma regulamentos de
                segurança complexos em informações acionáveis.
              </p>
            </div>
          </div>

          <p className="text">
            Garanta agora mesmo a melhor solução em <br />
            <span>
              prevenção de vulnerabilidade em suas inspeções de segurança!
            </span>
          </p>

          <CTAForm />
        </div>
      </article>

      <article className="about2">
        <div className="container vertical">
          <h1 className="title">
            Documentação Fotográfica: <br />
            <span>Evidências Visuais</span> Que Importam
          </h1>

          <div className="gallery">
            <div className="item">
              <figure>
                <img src={about2_1} alt="Homem mechendo em um tablet" />
              </figure>

              <p className="item_title">Capture Riscos Visualmente</p>

              <p className="item_text">
                Documente problemas de não conformidade e situações de risco por
                meio de fotos de alta qualidade, criando evidências irrefutáveis
                ​​vinculadas diretamente ao atendimento das Normas
                Regulamentadoras NR´s.
              </p>
            </div>

            <div className="item">
              <figure>
                <img src={about2_2} alt="Homem mechendo em um tablet" />
              </figure>

              <p className="item_title">Conexão Regulatória Direta</p>

              <p className="item_text">
                Cada foto é automaticamente associada ao item de regulamentação
                de segurança correspondente, criando uma conexão clara entre os
                problemas identificados e os requisitos de conformidade.
              </p>
            </div>
          </div>

          <CTAForm />
        </div>
      </article>

      <article className="about3">
        <div className="container">
          <div className=""></div>

          <div className="right">
            <h1 className="title">
              <span>Mapeie facilmente </span>
              seus ambientes de trabalho
            </h1>

            <div className="gallery">
              <div className="item">
                <div className="top">
                  <figure>
                    <img src={bullet} alt="Bullet Point" />
                  </figure>

                  <p className="item_title">
                    Mapeamento abrangente do espaço de trabalho
                  </p>
                </div>

                <p className="item_text">
                  Crie representações digitais detalhadas de seus ambientes de
                  trabalho com as ferramentas de mapeamento intuitivas do SAV.
                  Categorize os espaços por departamento, função ou nível de
                  risco para manter registros organizados.
                </p>
              </div>

              <div className="item">
                <div className="top">
                  <figure>
                    <img src={bullet} alt="Bullet Point" />
                  </figure>

                  <p className="item_title">Eficiência que economiza tempo </p>
                </div>

                <p className="item_text">
                  Experimente ganhos significativos de produtividade ao realizar
                  avaliações de risco. A abordagem estruturada do SAV, para o
                  mapeamento do ambiente, visa reduzir o tempo de inspeção em
                  até 40% em comparação com os métodos tradicionais.
                </p>
              </div>
            </div>

            <CTAForm />
          </div>
        </div>
      </article>

      <article className="mobile">
        <div className="container">
          <h1 className="title">
            <span>Mapeie facilmente </span>
            seus ambientes de trabalho
          </h1>

          <div className="gallery">
            <div className="item">
              <div className="top">
                <figure>
                  <img src={bullet} alt="Bullet Point" />
                </figure>

                <p className="item_title">
                  Mapeamento abrangente do espaço de trabalho
                </p>
              </div>

              <p className="item_text">
                Crie representações digitais detalhadas de seus ambientes de
                trabalho com as ferramentas de mapeamento intuitivas do SAV.
                Categorize os espaços por departamento, função ou nível de risco
                para manter registros organizados.
              </p>
            </div>

            <div className="item">
              <div className="top">
                <figure>
                  <img src={bullet} alt="Bullet Point" />
                </figure>

                <p className="item_title">Eficiência que economiza tempo </p>
              </div>

              <p className="item_text">
                Experimente ganhos significativos de produtividade ao realizar
                avaliações de risco. A abordagem estruturada do SAV, para o
                mapeamento do ambiente, visa reduzir o tempo de inspeção em até
                40% em comparação com os métodos tradicionais.
              </p>
            </div>
          </div>

          <CTAForm />
        </div>
      </article>
    </section>
  );
};

export default About;
